import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import CustomLink from "../link/customLink";
import CustomTable from "./CustomTable";
import OpenCloseItem from "../../General/OpenCloseItem/OpenCloseItem";
import {getSortableColumnSortClass} from "../../../helpers/functions";
import CustomTableListRow from "./customTableListRow";

class CustomTableList extends React.Component {

    moveRow = (id, afterId) => {
        const self = this;
        const rows = _.clone(this.props.data);

        const currentRow = _.filter(rows, function (r, index) { return index === id;})[0];
        const afterRow = _.filter(rows, function (r, index) { return index === afterId;})[0];

        const currentRowIndex = rows.indexOf(currentRow);
        const afterRowIndex = rows.indexOf(afterRow);

        // remove the current row
        rows.splice(currentRowIndex, 1);
        // put it after
        rows.splice(afterRowIndex, 0, currentRow);

        return rows;
    };

   render(){
       const {
           selectable,
           responsive,
           striped,
           columns,
           onSortedChange,
           onSelectAll,
           selected,
           onDatumSelect,
           data,
           orderBy,
           orderAsc,
           hasActions,
           actions,
           expandableRow,
           onTableRowExpand,
           expandedTableRows,
           totalColumns,
           nestedTableTitle,
           tableHover,
           customNestedTableComponent,
           actionOnLeft,
           withVerticalAlignedHeader,
           loadingRows,
           fixed
       } = this.props;
       const CustomNestedTableComponent = customNestedTableComponent;

       return (
           <div className={classNames("arag", responsive? "table-responsive" : "")}>
               <table className={classNames(
                   "table",
                   "table-striped",
                   "table-selectable",
                   "table-hover",
                   "table-vertical-aligned-header",
                   selectable ? "table-selectable" : "",
                   fixed ? "table-fixed" : "",
               )}>
                   <thead>
                   {nestedTableTitle && (
                       <tr className={"secondary-table-header"}>
                           <th colSpan={columns.length}>
                               {nestedTableTitle}
                           </th>
                       </tr>
                   )}
                   <tr>
                       {expandableRow && (
                           <th width="10px"/>
                       )}
                       {selectable && (
                           <th className={"control-checkbox"}>
                               <input
                                   type="checkbox"
                                   checked={data.length === _.size(selected) && data.length > 0}
                                   onChange={(evt) => onSelectAll(evt.target.checked)}
                               />
                           </th>
                       )}
                       {
                           columns.map(column => (
                               <th
                                   key={column.propertyName}
                                   style={column.style ? column.style : null}
                                   className={
                                       classNames(
                                           column.sortable ? "sortable" : "",
                                           getSortableColumnSortClass(orderBy, orderAsc, column.id)
                                       )
                                   }
                                   onClick={column.sortable ? () => onSortedChange(column.id) : null}
                               >
                                   {column.header}
                                   {column.sortable?
                                       [
                                           <span
                                               key={0}
                                               style={column.sortingStyle ? column.sortingStyle : null}
                                               className={
                                                   classNames(
                                                       "glyphicon",
                                                       "glyphicon-arrow-up",
                                                   )}
                                           />,
                                           <span
                                               key={1}
                                               className={
                                                   classNames(
                                                       "glyphicon",
                                                       "glyphicon-arrow-down",
                                                   )}
                                               style={column.sortingStyle ? column.sortingStyle : null}
                                           />
                                       ]
                                       :
                                       null}
                               </th>
                           ))
                       }
                       {(hasActions && !actionOnLeft) && (
                           <th>Actions</th>
                       )}
                   </tr>
                   </thead>
                   <tbody>
                   {
                       data.map((datum, index) => (
                           [
                               <CustomTableListRow {...this.props} index={index} datum={datum} moveRow={this.moveRow} />,
                               expandableRow && expandedTableRows.includes(index) ?
                                   <tr key={2}>
                                       <td colSpan={totalColumns}>
                                           {CustomNestedTableComponent ?
                                               <CustomNestedTableComponent
                                                   columns={expandableRow.columns}
                                                   data={_.get(datum, expandableRow.propertyNameWithData)}
                                               />
                                               :
                                               <CustomTable
                                                   accordionItemHeaderFormatter={expandableRow.accordionItemHeaderFormatter}
                                                   striped
                                                   tableHover
                                                   nestedTableTitle={expandableRow.nestedTableTitle}
                                                   data={
                                                       expandableRow.dataFormatter ?
                                                           expandableRow.dataFormatter(_.get(datum, expandableRow.propertyNameWithData))
                                                           :
                                                           _.get(datum, expandableRow.propertyNameWithData)
                                                   }
                                                   columns={expandableRow.columns}
                                                   {...expandableRow.nestedTableProps}
                                               />
                                           }

                                       </td>
                                   </tr> : null
                           ]
                       ))
                   }
                   </tbody>
               </table>
           </div>
       );
   }
};

CustomTableList.propTypes = {
    /** Array that contains the rows indexes that should have a loader */
    loadingRows: PropTypes.arrayOf(PropTypes.number),
    /** boolean indicating that the table should have a vertical aligned header */
    withVerticalAlignedHeader: PropTypes.bool,
    /** boolean indicating that when the table has actions they should appear on the left of the table */
    actionOnLeft: PropTypes.bool,
    /** The data that should be displayed. Can by an array of objects of any type and shape */
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    /** The columns of the list - table. The propertyName is used to match the desired property of the data objects.
     * eg: the data object {email : "user@test.io"} will be matched by the column: {propertyName: "email", header:
     * "Email!"}. If you wish to access nested properties from the data you should specify them again in the
     * propertyName separated with a dot "." eg: data: {user: {email : "user@test.io"}}, then the property name will be
     * propertyName: "user.email". The id property of is used for sorting. So it must match the correct sortBy key.
     * The formatter is a callback used to format the data as you wish. It is invoked with the datum. For example
     * formatting timestamp dates. the sortable prop specifies if the column is sortable
     * . The style property can be used to style the th as you want. The sorting style property can be used to
     * style the sorting arrows of the th as you want.*/
    columns: PropTypes.arrayOf(PropTypes.shape({
        propertyName: PropTypes.string.isRequired,
        header: PropTypes.string.isRequired,
        id: PropTypes.string,
        formatter: PropTypes.func,
        sortable: PropTypes.bool,
        style: PropTypes.object,
        sortingStyle: PropTypes.object,
    })).isRequired,
    /** Boolean indicating that the items are selectable. If set to true, the props selected, onDatumSelect,
     * onSelectAll MUST be specified */
    selectable: PropTypes.bool,
    /** Object containing the selected items */
    selected: PropTypes.object,
    /** Callback invoked when select all input is clicked. It will be invoked with a checked bool property
     * eg: (allSelectedChecked) => {} */
    onSelectAll: PropTypes.func,
    /** Callback invoked  when the use checks a row - item. It will be passed with the arguments: checked(bool),
     * index(number), datum(object), eg: (checked, index, datum) => {}*/
    onDatumSelect: PropTypes.func,
    /** Boolean prop that when is set to true an extra column will be displayed to display the actions - links.
     * If set to true the property actions must be specified */
    hasActions: PropTypes.bool,
    /** Array of the desired actions. The callback will be invoked when the corresponding action is clicked.
     * The callback function with have the row datum and row index passed as arguments.
     * If a custom component is defined then the actions wil be rendered according to it. The custom component will
     * also have available the props: datum, action & rowIndex */
    actions: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        callback: PropTypes.func.isRequired,
        customComponent: PropTypes.element
    })),
    /** Boolean indicating if the table should be responsive */
    responsive: PropTypes.bool,
    /** Boolean indicating if the rows should be striped */
    striped: PropTypes.bool,
    /** Callback invoked on sortable columns click. It will be invoked  with an argument of the column in property.
     * MUST be specified IF column is sortable*/
    onSortedChange: PropTypes.func,
    /** String that must match the sortable column id property. MUST be specified IF column is sortable*/
    orderBy: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** Boolean indicating if the sort order is ascending or descending */
    orderAsc: PropTypes.bool,
    /** object that describes the expandable row table. You can also add all the properties of The Table component
     * in the property nestedTableProps and they will be passed to the nested component. If you want to map-alter the
     * data before display use the dataFormatter function property. It will be called with the data for display. It
     * MUST return the altered data.*/
    expandableRow: PropTypes.shape({
        columns:  PropTypes.arrayOf(PropTypes.shape({
            propertyName: PropTypes.string.isRequired,
            header: PropTypes.string.isRequired,

            formatter: PropTypes.func,
        })),
        propertyNameWithData: PropTypes.string.isRequired,
        dataFormatter: PropTypes.func,
        nestedTableProps: PropTypes.object
    }),
    /** The header title of the nested table of each row */
    nestedTableTitle: PropTypes.string,
    /** flag that indicates that the table should have a table-hover style */
    tableHover: PropTypes.bool,
    /** Custom component to replace the built in nested Table component of each row. It will have the
     * expandable table row passed as a prop */
    customNestedTableComponent: PropTypes.element,
};

export default CustomTableList;